import React from 'react';
import { Container, Row, Col, Image, Card } from 'react-bootstrap';
import aboutImage from '../../assets/about-cab.png'; // Replace with your image path
import styles from './About.module.css';

const About = () => {
  return (
    <div className={styles.aboutSection}>
      <Container className="py-5">
        <Row className="align-items-center">
          <Col md={6}>
            <Image
              src={aboutImage}
              alt="Our Cabs"
              fluid
              className="rounded shadow"
            />
          </Col>
          <Col md={6}>
            <h2 className={styles.title}>About Rave Cabs</h2>
            <p className={styles.description}>
              Rave Cabs Private Limited is a modern, reliable, and customer-first cab service based in India. With a focus on safety, punctuality, and professionalism, we aim to redefine your travel experience.
            </p>
            <p className={styles.description}>
              Whether you're commuting daily, heading to the airport, or planning a city tour, Rave Cabs offers affordable and comfortable rides with experienced drivers.
            </p>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={4}>
            <Card className={styles.featureCard}>
              <Card.Body>
                <h5>🚗 Well-Maintained Fleet</h5>
                <p>Our vehicles are regularly serviced to ensure comfort and safety.</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className={styles.featureCard}>
              <Card.Body>
                <h5>🕒 On-Time Pickups</h5>
                <p>Time is valuable. We ensure our drivers arrive on schedule every time.</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className={styles.featureCard}>
              <Card.Body>
                <h5>👨‍✈️ Trained Drivers</h5>
                <p>Our drivers are courteous, experienced, and committed to your safety.</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;